export default {
  ls3df: {
    banner: 'LS3DF',
    title: 'LS3DF',
    describe:`
    The LS3DF (Linear Scaling Three Dimensional Fragment Method) algorithm is based on the idea of divide and conquer.
    It divides the large system into many small fragments. Each small fragment is calculated separately
    using the DFT method, and then the calculated small fragments are combined and spliced together to
    obtain the electronic structure properties of the large system. Currently, LS3DF supports self-consistent
    calculation of electronic structure and structural optimization calculation. The LS3DF software
    package uses the same authentication certificate as PWmat. If the server already has a PWmat
    certificate file, there is no need to re-apply or install it. The installation packages
    listed below all use the GPU card UUID to authenticate the LICENSE. Longxun generates the
    certificate file pwmat.lic based on the UUID provided by the user. The certificate file
    needs to be placed in the server /opt/pwmat/ folder. If the user does not have the root permission
    of the server and cannot place the certificate file in the /opt/pwmat/ directory, you can specify
    the folder where the LICENSE file is located by following the -lic-path parameter after LS3DF when
    running LS3DF: LS3DF -lic-path 'path-to-pwmat.lic'. Except for supercomputing centers and large-scale
    clusters, most users download this version to install or update the software. Before downloading the
    LS3DF installation package, please first confirm the MPI and CUDA versions on your server and download
    the installation package according to the corresponding relationship. If you have any unclear operation,
    please contact Longxun staff in time or send an email to support@pwmat.com ! ! !
    `,
    tableR0C3: 'LS3DF Version',
    note1: 'LS3DF Installation Instructions',
    describe2: `
    The installation packages listed below all use the method of starting the server.py service to
    authenticate LICENSE when logging into the cluster or managing the node.
    Users of supercomputing centers or large-scale clusters all download this version to install or
    update the software. Before downloading the LS3DF installation package,
    please first confirm the MPI and CUDA versions on your server and download the installation package
    according to the corresponding relationship. Special attention should be paid to the fact that
    when running this version of LS3DF, the IP and communication port of the node where the LICENSE service
    is deployed need to be specified in LS3DF. For the IP and communication port setting methods,
    please refer to the LICENSE service installation instructions ! ! !
    `,
  },
  matpl: {
    banner: 'MatPL',
    title: 'MatPL',
    describe:`
    The Materials Potential Library (MatPL) is an open-source library developed under the GNU license
    and is used to rapidly generate machine learning force fields with accuracy comparable to ab initio molecular dynamics (AIMD).
    `,
    describe2:`
    MatPL provides a complete set of solutions, including machine learning force field model training platform,
    Lammps interface solution, active learning platform, data format conversion tools, etc. In addition,
    it also provides data and model warehouses, as well as detailed user manuals.
    These functions and resources provide users with all-round support,
    allowing users to use MatPL for scientific computing and simulation more conveniently and efficiently.
    `,
    tableR0C1: 'Version',
    tableR0C2: 'release date',
    tableR0C3: 'Dependency library version',
    tableR0C4: 'Installation package link',
    tableR0C5: 'Manual link',
  },
}